module.exports = __webpack_public_path__ + "assets/f512b6404c764f7db64a76324f0b04dd.mp3";